<template>
  <span id="flower-invoice-detail" v-if="invoice.type === flowerInvoiceType">
    <i class="el-icon-search header-info-dialog-value icon-action" id="btn-flower-invoice-detail" @click="handleOpenDialog" size="mini" icon="el-icon-plus"></i>
    <el-dialog
      width="90%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
    <span slot="title">
        <el-row :gutter="20">
          <el-col :span="12">
            <span class="el-dialog__title">
              {{ $t('invoices.flower.flowerInvoice') }}
            </span>
          </el-col>
          <el-col :span="11" class="text-align-end">
            <credit-and-re-bill
              :invoice-id="invoice.id"
              :invoice-number="invoice.number"
              :bill-to="`${invoice.billToAccountNumber} - ${invoice.billToAccountName}`"
              :invoice-date="invoice.date"
              :total-amount="invoice.totalAmount"
              :credited="invoice.credited"
              :posted="invoice.posted"
              :parent-invoice-number="invoice.parentNumber"
              :success-handler="creditAndReBillSuccessHandler"
            />
          </el-col>
        </el-row>
      </span>
      <el-row :gutter="10">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.invoiceNum') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.number }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.flower.date') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.date | moment('MM/DD/YYYY') }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.flower.type') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoiceTypeName(invoice.type) }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.billTo') }}</label>
        </el-col>
        <el-col :span="4">
          <el-tooltip class="item" effect="dark" :enterable="false" :content="invoice.billToAccountNumber + ' ' + invoice.billToAccountName" placement="top-start">
            <span class="span-small-list">{{ invoice.billToAccountNumber }} - {{invoice.billToAccountName }}</span>
          </el-tooltip>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.flower.consignee') }}</label>
        </el-col>
        <el-col :span="4">
          <el-tooltip class="item" effect="dark" :enterable="false" :content="invoice.consigneeAccountNumber + ' ' + invoice.consigneeAccountName" placement="top-start">
            <span class="span-small-list">{{ invoice.consigneeAccountNumber }} - {{ invoice.consigneeAccountName }}</span>
          </el-tooltip>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.deliverTo') }}</label>
        </el-col>
        <el-col :span="4">
          <el-tooltip class="item" effect="dark" :enterable="false" :content="invoice.deliverToAccountNumber + ' ' + invoice.deliverToAccountName" placement="top-start">
            <span class="span-small-list">{{ invoice.deliverToAccountNumber }} - {{ invoice.deliverToAccountName }}</span>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.numOfShipments') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.totalShipments }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.flower.numberOfUnits') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.numberOfUnits }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.cubes') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.totalCubes }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.flower.credited') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ invoice.credited ? statusBoolean.yes.label : statusBoolean.no.label }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.totalAmount') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.totalAmount | currency }}</span>
        </el-col>
      </el-row>

      <el-row class="default-section-title-no-padding">
        <el-col :span="24" class="default-section-title">
          <span class="title-list">
            {{ $t('invoices.invoiceDetails') }}
          </span>
        </el-col>
      </el-row>

      <el-table
        class="flower-invoice-details-table"
        size="mini"
        tooltip-effect="dark"
        v-loading="searching"
        stripe
        :data="details"
        :empty-text="$t('invoices.invoiceHasNoDetails')"
      >
        <el-table-column
          type="index"
          :label="$t('invoices.flower.sequence')"
          min-width="5"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="shipmentNumber"
          :label="$t('invoices.flower.shipment')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="shipperAccountName"
          :label="$t('invoices.flower.shipper')"
          min-width="20"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="productCode"
          :label="$t('invoices.flower.productCode')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="productName"
          :label="$t('invoices.flower.product')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="poNumber"
          :label="$t('invoices.flower.poNumber')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="length"
          :label="$t('invoices.flower.length')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="width"
          :label="$t('invoices.flower.width')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="height"
          :label="$t('invoices.flower.height')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="cubes"
          :label="$t('invoices.cubes')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="numberUnits"
          :label="$t('invoices.flower.numberUnits')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="totalCubes"
          :label="$t('invoices.flower.totalCubes')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          :label="$t('invoices.flower.amount')"
          min-width="7"
          align="center"
          :showOverflowTooltip="true" >
        <template slot-scope="scope">
          <span> {{ scope.row.amount | currency }} </span>
        </template>
      </el-table-column>
      </el-table>
      <div class="pagination-footer" v-show="totalDetails > 0">
        <span class="el-pagination__total">
          <span class="el-pagination__title">{{ $t('common.total') }}</span>
          {{ totalDetails }}
        </span>
        <el-pagination
          :total="totalDetails"
          :current-page.sync="searchParams.page"
          :page-sizes="sizes"
          :page-size="searchParams.rows"
          @size-change="handleSearchChangeLimit"
          @current-change="handleSearchChangePage"
          layout="sizes, prev, pager, next, jumper"
        ></el-pagination>
    </div>
    </el-dialog>
  </span>
</template>

<script>
import constants from '@/utils/constants';
import { INVOICES_SEARCH } from '@/store/actions';
import CreditAndReBill from './CreditAndReBill';

export default {
  name: 'FlowerInvoiceDetailDialog',
  components: { CreditAndReBill },
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },
  computed: {
    flowerInvoiceType() {
      return constants.INVOICE.TYPES[1].value;
    },
    sizes() {
      return constants.TABLES.DEFAULT_LIMIT_SIZES;
    },
    statusBoolean() {
      return constants.STATUS_BOOLEAN;
    }
  },
  data() {
    return {
      dialogVisible: false,
      details: [],
      totalDetails: 0,
      searching: false,
      searchParams: {
        invoiceId: 0,
        invoiceType: 0,
        rows: constants.TABLES.DEFAULT_LIMIT,
        page: constants.TABLES.DEFAULT_PAGE,
        pageResults: true
      }
    };
  },
  methods: {
    creditAndReBillSuccessHandler() {
      this.invoice.credited = true;
      this.$store.dispatch(INVOICES_SEARCH, {});

      const routeData = this.$router.resolve({
        path: '/customerCenter/manageShipments',
        query: {
          outboundDateFrom: this.invoice.date,
          outboundDateTo: this.invoice.date,
          consigneeAccountId: this.invoice.consigneeAccountId,
          consigneeAccountName: `${this.invoice.consigneeAccountName} - ${this.invoice.consigneeAccountNumber}`,
          invoiceNumber: this.invoice.number,
        }
      });
      window.open(routeData.href, '_blank');
    },
    handleOpenDialog() {
      this.dialogVisible = true;
      this.searchParams.invoiceId = this.invoice.id;
      this.searchParams.invoiceType = this.invoice.type;
      this.handleSearch();
    },
    handleSearchChangeLimit(val) {
      this.searchParams.rows = val;
      this.searchParams.page = constants.TABLES.DEFAULT_PAGE;
      this.handleSearch();
    },
    handleSearchChangePage(val) {
      this.searchParams.page = val;
      this.handleSearch();
    },
    handleSearch() {
      this.searching = true;
      this.$store.dispatch('invoices/details', this.searchParams).then(
        (response) => {
          this.details = response.data;
          this.totalDetails = response.totalRows;
        }
      ).finally(() => {
        this.searching = false;
      });
    },
    invoiceTypeName(typeId) {
      return constants.INVOICE.TYPES.find(type => type.value === typeId).label;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
span#flower-invoice-detail {
  th {
    line-height: 1.15;
    .cell {
      line-height: 16px;
      height: 16px;
    }
  }
}
</style>
